export { default, TrainingLandingV3Page } from './container'
